import * as actionTypes from "../actions/actionTypes";

const initialState = {
  openingHours: undefined,
  error: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_OPENINGHOURS:
      return {
        ...state,
        error: false,
      };

    case actionTypes.SET_OPENINGHOURS:
      return {
        ...state,
        openingHours: action.openingHours,
        error: false,
      };

    case actionTypes.FETCH_OPENINGHOURS_FAILED:
      return {
        ...state,
        error: action.error || true,
      };

    case actionTypes.UPDATE_OPENINGHOURS_STATUS:
      if (!Array.isArray(state.openingHours)) {
        return state;
      }
      return {
        ...state,
        openingHours: state.openingHours.map((oh) =>
          oh.storageId === action.storageId
            ? { ...oh, status: action.status, needsReview: false }
            : oh
        ),
      };

    default:
      return state;
  }
};

export default reducer;
